import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Col, Row } from 'react-bootstrap'
import { SectionName } from '@ztechapps/webui.util'
import { GridListViewModeEnum } from '../GridListToggle'
import { useAssetPageContext } from './Context'
import { DataAction } from './DataAction'
import { EmptyAssets } from './EmptyAssets'
import { GridView } from './GridView'
import { ListView } from './ListView'
import { NoMatchingAssets } from './NoMatchingAssets'

export const Layout = () => {
  const { viewMode, assets, allAssets } = useAssetPageContext()
  const hasAnyAssets = !isEmpty(assets)
  const hasFilteredAssets = !isEmpty(allAssets)

  return (
    <div>
      <SectionName
        title="Images, videos and documents"
        description="Manage here the images, videos and documents (assets) that are related to this document."
      />
      {hasAnyAssets ? (
        <Row className="mt-2">
          <Col md={12}>
            <DataAction />
          </Col>
          <Col md={12}>
            {hasFilteredAssets ? (
              viewMode === GridListViewModeEnum.Grid ? (
                <GridView />
              ) : (
                <ListView />
              )
            ) : (
              <NoMatchingAssets />
            )}
          </Col>
        </Row>
      ) : (
        <EmptyAssets />
      )}
    </div>
  )
}
